import o from "./index692.js";
import { withInstall as t } from "./index604.js";
const m = t(o);
export {
  m as ElTooltip,
  m as default
};
